import { frontendURL } from 'dashboard/helper/URLHelper';
import CatalogView from './CatalogView.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/catalog'),
    name: 'catalog_view',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: CatalogView,
  },
];
